
import Vue from "vue";
import { CalendarEventReminder } from "@/models/calendar-event-reminder";
import AppCalendarEventReminder from "./CalendarEventReminder.vue";
import { requestNotificationPermission } from "@/utils/notifications";

export default Vue.extend({
	props: {
		reminders: {
			type: Array as () => CalendarEventReminder[],
			required: true
		},
		// Toon de link "Herinnering toevoegen" onder de lijst
		showAdd: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		add() {
			this.$emit("add");
			requestNotificationPermission();
		}
	},
	components: {
		AppCalendarEventReminder
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
